/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit CustomOption/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFormat from 'Data/format.js'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function CustomOption({
  children,
  viewPath = "/App/Account/Content/Calendar/New/Content/Content/CollapsibleSidebar/Filters/AppointmentTypes/Content/Content/CustomOption"
  
}) {
let itemColorIdValueData = fromData.useDataFormat({ viewPath,
context: 'item',
path: 'color_id',
format: fromFormat.appointmentTypeColor,
})
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let itemFullNameValueData = fromData.useDataValue({ viewPath,
context: 'item',
path: 'full_name',
})
let dtSpaceLs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.ls'
        })
let dtColorsNeutral900 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.900'
        })
  return (<React.Fragment
>
<div
  data-testid="CustomOption.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<div
  data-testid="CustomOption.Horizontal:1"
  data-view-path={viewPath}
 style={{'--w-1-vkJfb': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--h-2-vkJfb': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--bc-3-vkJfb': itemColorIdValueData}}
 className={`views-block ${styles.Horizontal1}`}
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 marginLeft={dtSpaceLs}
 color={dtColorsNeutral900}
 data="item.full_name"
 text={itemFullNameValueData}
/>
</div>
{children}
</React.Fragment>)
}